import { SvgIcon } from '@mui/material';
import type { Variants } from 'motion/react';
import { motion, useAnimation } from 'motion/react';
import { forwardRef, useImperativeHandle } from 'react';

import type { AnimatedIconProps, AnimeatableIconRef } from './types';

const svgVariants: Variants = {
  visible: {
    y: 0,
  },
  animate: {
    y: [0, -5, -3],
    transition: {
      duration: 0.5,
      times: [0, 0.6, 1],
    },
  },
};

const houseVariants: Variants = {
  visible: {
    opacity: 1,
  },
  animate: {
    opacity: [0, 1],
    pathLength: [0, 1],
    transition: {
      delay: 0.3,
      duration: 0.3,
      opacity: { duration: 0.1, delay: 0.3 },
    },
  },
};

const MapPinHouseIcon = forwardRef<AnimeatableIconRef, AnimatedIconProps>(
  ({ size = 28, strokeWidth = 2, titleAccess, color, fontSize }, ref) => {
    const controls = useAnimation();

    useImperativeHandle(ref, () => ({
      startAnimation: () => controls.start('animate'),
      stopAnimation: () => controls.start('visible'),
    }));

    return (
      <SvgIcon
        titleAccess={titleAccess}
        color={color}
        fontSize={fontSize}
        sx={fontSize ? undefined : { width: size, height: size }}
      >
        <motion.svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          variants={svgVariants}
          initial="visible"
          animate={controls}
        >
          <path d="M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2" />
          <circle cx="10" cy="10" r="3" />
          <motion.path
            d="M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z M18 22v-3"
            variants={houseVariants}
            initial="visible"
            animate={controls}
          />
        </motion.svg>
      </SvgIcon>
    );
  }
);

MapPinHouseIcon.displayName = 'MapPinHouseIcon';

export { MapPinHouseIcon };
